require('./shared/layout');
import $ from 'jquery';
import Axios from 'axios';
import { parseQueryParams } from './shared/utils';
const axios = Axios.create({ withCredentials: true });

$(document).ready(function () {
  var searchParams = parseQueryParams(window.location.search || '');
  var magicToken = searchParams.access_token;

  var setFormError = function (err) {
    $('.spinner-wrap').hide();
    $('.section_layout').addClass('errored');
    let msg = err.message || err
    if (msg === 'Unauthorized') {
      msg = 'Invalid magic link'
    }

    $('#form_error').text(msg);
  };

  var onSignedin = function () {
    var redirecUri = searchParams.redirect;
    if (!redirecUri) {
      // check of any passed state params
      if (searchParams.state) {
        var originSearchStr;
        try {
          originSearchStr = atob(searchParams.state);
        } catch (e) { }

        if (originSearchStr) {
          var originSearchParams = parseQueryParams(originSearchStr);
          if (originSearchParams.redirect) {
            redirecUri = originSearchParams.redirect;
          }
        }
      }
    }

    if (redirecUri) {
      redirecUri = decodeURI(redirecUri);
    } else {
      redirecUri = process.env.LOGIN_REDIRECT_URL;
    }

    window.location.href = redirecUri;
  };

  var onSiginFailed = function (err) {
    setFormError(err);
  };

  var signinWithConnectCode = function () {
    var apiUri = process.env.AUTH_API_BASE + '/auth/signin/magic-link';
    axios
      .post(apiUri, { access_token: magicToken })
      .then((res) => {
        console.log('magic-login-res', res.data);
        // const body = res.data || {};
        onSignedin();
      })
      .catch((e) => {
        var err = e && e.response && e.response.data;
        onSiginFailed(err);
      });
  };

  if (magicToken) {
    signinWithConnectCode();
  } else {
    var err = {
      message: 'missing magic link token'
    };
    setFormError(err);
  }
});
